import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminProfessionals = () => {
  const [pros, setPros] = useState([]);
  const [filteredPros, setFilteredPros] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProId, setSelectedProId] = useState(null);
  const [appointments, setAppointments] = useState([]);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    const fetchPros = async () => {
      try {
        const res = await axios.get('https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/admin/professionals');
        setPros(res.data);
        setFilteredPros(res.data);
      } catch (err) {
        console.error('Erreur récupération professionnels :', err);
      }
    };
    fetchPros();
  }, []);

  useEffect(() => {
    const filtered = pros.filter(pro => {
      const search = searchTerm.toLowerCase();
      return (
        `${pro.first_name} ${pro.last_name}`.toLowerCase().includes(search) ||
        pro.specialities?.some(s => s.toLowerCase().includes(search)) ||
        pro.languages?.some(l => l.toLowerCase().includes(search)) ||
        pro.cultures?.some(c => c.toLowerCase().includes(search)) ||
        (pro.zone || '').toLowerCase().includes(search)
      );
    });
    setFilteredPros(filtered);
  }, [searchTerm, pros]);

  const handleViewDetails = async (proId) => {
    if (selectedProId === proId) {
      setSelectedProId(null);
      setAppointments([]);
      setInvoices([]);
      return;
    }

    setSelectedProId(proId);
    try {
      const [resAppt /*, resInv*/] = await Promise.all([
        axios.get(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/admin/professionals/${proId}/appointments`),
        // axios.get(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/admin/professionals/${proId}/invoices`)
      ]);
      setAppointments(resAppt.data);
      // setInvoices(resInv.data);
    } catch (err) {
      console.error('Erreur récupération détails professionnel :', err);
      setAppointments([]);
      setInvoices([]);
    }
  };

  return (
    <div style={{ padding: '30px', fontFamily: 'Arial, sans-serif' }}>
      <h2 style={{ marginBottom: '20px' }}>👨‍⚕️ Liste des professionnels</h2>

      <input
        type="text"
        placeholder="🔎 Rechercher par nom, spécialité, langue, zone..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          padding: '10px',
          marginBottom: '20px',
          width: '100%',
          maxWidth: '400px',
          border: '1px solid #ccc',
          borderRadius: '4px'
        }}
      />

      <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
        <thead style={{ backgroundColor: '#f4f4f4' }}>
          <tr>
            <th style={cellStyle}>Nom</th>
            <th style={cellStyle}>Email</th>
            <th style={cellStyle}>Téléphone</th>
            <th style={cellStyle}>Spécialités</th>
            <th style={cellStyle}>Langues</th>
            <th style={cellStyle}>Culture</th>
            <th style={cellStyle}>Zone</th>
            <th style={cellStyle}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredPros.map((pro) => (
            <React.Fragment key={pro.user_id}>
              <tr style={{ borderBottom: '1px solid #ddd' }}>
                <td style={cellStyle}>{pro.first_name} {pro.last_name}</td>
                <td style={cellStyle}>{pro.email}</td>
                <td style={cellStyle}>{pro.phone}</td>
                <td style={cellStyle}>{pro.specialities?.join(', ')}</td>
                <td style={cellStyle}>{pro.languages?.join(', ')}</td>
                <td style={cellStyle}>{pro.cultures?.join(', ')}</td>
                <td style={cellStyle}>{pro.zone || '—'}</td>
                <td style={cellStyle}>
                  <button onClick={() => handleViewDetails(pro.user_id)} style={buttonStyle}>
                    {selectedProId === pro.user_id ? 'Masquer' : 'Voir détails'}
                  </button>
                </td>
              </tr>

              {selectedProId === pro.user_id && (
                <tr>
                  <td colSpan="8" style={{ backgroundColor: '#fafafa' }}>
                    <div style={{ padding: '15px', borderTop: '1px solid #ccc' }}>
                      <h4 style={{ marginBottom: '10px' }}>📅 Rendez-vous</h4>
                      {appointments.length === 0 ? (
                        <p style={{ fontStyle: 'italic' }}>Aucun rendez-vous.</p>
                      ) : (
                        <ul style={{ paddingLeft: '20px' }}>
                          {appointments.map((appt) => (
                            <li key={appt.appointment_id} style={{ marginBottom: '5px' }}>
                              <strong>{new Date(appt.start_time).toLocaleString()}</strong> — {appt.service_name}<br />
                              Avec : {appt.patient_name} — <em>Statut :</em> <strong>{appt.status}</strong>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const cellStyle = {
  padding: '10px',
  textAlign: 'left',
  verticalAlign: 'top',
  borderRight: '1px solid #eee',
};

const buttonStyle = {
  padding: '6px 12px',
  backgroundColor: '#1976d2',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '14px',
};

export default AdminProfessionals;